import React, { useState } from 'react';
import { Box, Chip } from '@mui/material';
import CompanyUser from 'store/types/CompanyUser';
import { EMPTY_STRING_VALUE } from 'util/Format';

interface PortalRoleChipsProps {
  functions?: CompanyUser['functions'];
  maxVisible?: number;
}

const PortalRoleChips: React.FunctionComponent<PortalRoleChipsProps> = ({ functions = [], maxVisible = 2 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!functions.length) {
    return <>{EMPTY_STRING_VALUE}</>;
  }

  const hasAdditionalFunctions = functions.length > maxVisible;
  const displayedFunctions = expanded ? functions : functions.slice(0, maxVisible);

  const handleToggle = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setExpanded((current) => !current);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 0.5,
        width: '100%',
        py: 0.5,
      }}
    >
      {displayedFunctions.map((customerFunction) => (
        <Chip key={customerFunction.id} label={customerFunction.functionName} color={'secondary'} size={'small'} />
      ))}

      {hasAdditionalFunctions && (
        <Chip
          label={expanded ? 'Show less' : `+${functions.length - maxVisible} more`}
          size={'small'}
          clickable
          aria-expanded={expanded}
          onClick={handleToggle}
          onMouseDown={(event) => event.stopPropagation()}
          sx={{
            flexShrink: 0,
          }}
        />
      )}
    </Box>
  );
};

export default PortalRoleChips;
